import React from 'react';
import { Text, Select, Stack, styled } from '@/theme/index';

export interface ListingsSortFilterProps {
  currentSortType: string;
  setSearchParams: (
    arg: (searchParams: URLSearchParams) => URLSearchParams
  ) => void;
}

const StyledSelect = styled(Select)(() => ({
  width: 'fit-content',
  height: '39px',
  fontSize: '14px',
  '&:hover': {
    boxShadow: 'none',
  },
  '&::after': {
    content: 'none',
  },
  '&::before': {
    content: 'none',
  },
}));

export function ListingsSortFilter({
  currentSortType,
  setSearchParams,
}: ListingsSortFilterProps) {
  const selectHandlerCopy = (value: string) => {
    setSearchParams((searchParams) => {
      const param = 'sort_listings';
      searchParams.set(param, value);
      return searchParams;
    });
  };

  const options = [
    { display: 'Newest', value: 'newness' },
    { display: 'Highest Price', value: 'price-desc' },
    { display: 'Lowest Price', value: 'price-asc' },
  ];

  return (
    <Stack alignItems="center" direction="row">
      <Text variant="body2" sx={(theme) => ({ marginRight: theme.spacing(1) })}>
        Sort:
      </Text>
      <StyledSelect
        onOptionSelect={selectHandlerCopy}
        options={options}
        id="sort-select"
        value={currentSortType || 'newness'}
        variant="standard"
        autoWidth
      />
    </Stack>
  );
}
